import { useEffect } from "react";
import { useSearchParams, useNavigate, useLocation } from "react-router-dom";

export default function LegacyLangRedirect() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    const lang = params.get("lang");
    if (lang && ["en", "fr", "de"].includes(lang)) {
      navigate(`/${lang}${pathname === "/" ? "" : pathname}`, { replace: true });
    } else if (lang === "nl") {
      navigate(pathname, { replace: true });
    }
  }, [params, pathname, navigate]);

  return null;
}
